import { WizardState } from '@hooks/utils/wizard-types';

export type SectionKey = keyof Omit<PvWizardSections, '__typename' | 'offerSection'>;

export type QuestionsBySectionMap = { [key: SectionKey | string]: string[] };

export type ValueOf<T> = T[keyof T];

export type UpdateAnswers = (updatedAnswer: PvWizardResultsQueryVariables) => void;

export enum QuestionKeys {
  houseType,
  householdSize,
  roofPitch,
  roofAlignment,
  federalState,
  hasVehicle,
  vehicleType,
  avgMileage,
  daysToCharge,
  wantsSolarStorage,
  roofDetails
}

export type WizardContentProps<T> = {
  questions: PvWizardQuestion[];
  onAnswerUpdated: UpdateAnswers;
  nextStep: () => void;
  previousStep: () => void;
  showNextButton?: boolean;
  showBackButton?: boolean;
  wizardState: WizardState;
  sectionKey: String;
  sectionInfo?: PvWizardSection['info'];
  result?: T;
};

const partnerNames = ['LichtBlick', 'zolar', 'Otovo'];

export type Partners = typeof partnerNames[number];

export const isPartners = (value: unknown): value is Partners[] => {
  if (!Array.isArray(value)) {
    return false;
  }

  return value.every(item => partnerNames.includes(item));
};

export const isWizardDataType = (obj: unknown): obj is WizardDataType => {
  if (typeof obj !== 'object' || obj === null) return false;

  const keys: (keyof WizardDataType)[] = [
    'AbdeckungEigenbedarfInKwh',
    'AbdeckungEigenbedarfInProzent',
    'Baujahr',
    'Co2Ersparnis',
    'Dachbeschaffenheit',
    'Dachneigung',
    'EAutoVorhanden',
    'EurErsparnis',
    'Haustyp',
    'Himmelsausrichtung',
    'Personenanzahl',
    'SonnenKmReichweite',
    'SpeicherGewuenscht'
  ];

  for (const key of keys) {
    if (!(key in obj)) {
      return false;
    }
  }

  return true;
};
